export const otpInputMaxLength = "4";

export const tableConfigs = {
    NGO_TABLE: {
      "Name of the NGO": "name",
      "NGO ID": "_id",
      "NGO PAN": "pan_card",
      "Total 10BD Amount": "total_10bd_available_amount",
      'Total 10BD Certificates' : "total_10bd_certificates",
      "Total 10BE Amount Received" :"total_10be_amount_received",
      "Total 10BE Certificate Received" : "total_10be_certificate_received",
      "Total 10BE Amount Matched" : "total_10be_amount_matched",
      "Total 10BE Certificates Matched" : "total_10be_certificate_matched",
      "Details": "details",
    },
    EMAIL_TABLE: {
      "Donor Name": "user_name",
      "Email": "user_email",
      "Phone": "user_phone",
      "PAN": "user_pan_card",
      "FY": "",
      "10BD Amount": "total_10bd_amount",
      "certificates expected": "expected_certificates",
      "certificates approved": "approved_count",
      "certificates Amount_matched": "amount_matched_count",
      "Emails sent for": "email_sent_for",
      "Emails remaining": "email_remaining",
      "Email Details": "details",
    },
    STATUS_TABLE: {
      "S.No" : "",
      "UIN(PAN of Donor)" : "user.pan_card",
      "Donor" : "user.name",
      "Amount" : "certificates.amount",
      "Certificate Status" : "",
      "Approve Status" : "",
    }
  };
  